import React from 'react'
import {Offer} from '../../types'

export interface NoShowPolicyProps {
  offer: Offer
}

const NoShowPolicy = ({offer}: NoShowPolicyProps) => {
  return (
    <div>
      <h3 className="font-semibold text-base border-b mb-2">No Show Policy</h3>
      <p dangerouslySetInnerHTML={{__html: offer?.noShowFee?.description}} />
    </div>
  )
}

export default NoShowPolicy
